export type ThemePreference = 'light' | 'dark' | 'system';

export function parseThemePreference(value: string | null | undefined): ThemePreference | null {
  if (value === 'light' || value === 'dark' || value === 'system') {
    return value;
  }
  return null;
}

export function resolveTheme(preference: ThemePreference | null, systemIsDark: boolean) {
  if (preference === 'light' || preference === 'dark') {
    return preference;
  }
  return systemIsDark ? 'dark' : 'light';
}
